<ul>
    <li>voiceCallId: {{attributes?.voiceCallId}}</li>
    <li>participantType: {{attributes?.participantType}}</li>
    <li>dialerType: {{attributes?.dialerType}}</li>
    <li>parentId: {{attributes?.parentId}}</li>
    <li>isOnHold: {{attributes?.isOnHold}}</li>
    <li>hasSupervisorBargedIn: {{attributes?.hasSupervisorBargedIn}}</li>
</ul>